<script>
    import Document from './Document.svelte';

    export let data; 
    export let crosswalk;

    let microchipID;
    let showDocument;
    let testUrl;
    let placeholderImg;
    let pdfUrl;
    let showNoRecordsFound;

    let helperText = microchipID ? "No records found" : "Enter a microchip number";

    function serveDocument(){

        if (microchipID) {
            // strip input of any special characters
            let cleanChipID = microchipID.replace(/\D/g, '');

            console.log(cleanChipID)

            // match input with PDF url
            testUrl = data[cleanChipID];

            console.log(testUrl)
            
            // if it exists, embed the PDF
            if (testUrl) {
                pdfUrl = data[cleanChipID];
                showDocument = true;
                showNoRecordsFound = false;
                placeholderImg = crosswalk.get( cleanChipID ).img
                console.log(pdfUrl,placeholderImg)
            } else {
                // if not...
                showDocument = false;
                helperText = "No records found";
                showNoRecordsFound = true;
            }  
        } else {
            showDocument = false;
            helperText = "Enter a microchip number";
            showNoRecordsFound = true;
        }
          
    }

    function clearInputValue(){
        microchipID = '';
        showDocument = false;
        showNoRecordsFound = false;
    }

    // function testFunction(){
    //     microchipID = '991001001684373';
    //     serveDocument();
    // }
</script>


<form action="#" method="GET" autocomplete="off">
    <label for="chip-input">
        Enter your dog’s 15-digit microchip number
    </label>
    <!-- <p class="helper">Microchip numbers are 15 digits.</p> -->
    <div class="input-container">
        <input 
        id="chip-input" 
        type="search" 
        autocomplete="off"
        bind:value={microchipID}
        placeholder="999999999999999"
        >

        <button id="submit" type="submit" on:click|preventDefault={serveDocument} aria-disabled={!microchipID}>
            Submit
        </button>
        
        <button id="clear" class="clear" on:click|preventDefault={clearInputValue} aria-disabled={!microchipID}>
            Clear
        </button>
    </div>
    <!-- <button style="border: 1px solid red;" on:click|preventDefault={testFunction}>
        TEST
    </button> -->
</form>

<div id="result-container">

    {#if showDocument}

    <a href={pdfUrl} target=_blank rel="nofollow">
        <Document
        img={placeholderImg}
        alt="An image of a certificate of veterinary inspection"
        />
    </a>

    <p class="download-link"><a href={pdfUrl} target=_blank rel="nofollow" download>Click to download this document in full</a></p>
    {/if}

    {#if showNoRecordsFound}
        <p class="no-results">{ helperText }</p>
    {/if}
    
</div>